class ZendeskModel {
    constructor() {
      this.id = null;
      this.created_at = null;
      this.description = null;
      this.priority = null;
      this.status = null;
      this.subject = null;
      this.type = null;
      this.tickets = [];
      this.ticketCount = []
      this.memberDetails = [];
      this.total = 0;
      this.activeSubject = null;
      this.activeMessage = null;
      this.statusText = null;
      this.statusColor = null;
  
      this.ticketDescriptionCount = 0;
      this.ticketDescription = [];
      this.chatStatus = null;
    }
  
    getStatusColor(status) {
      switch (status) {
        case 'open':
          return 'warning';
          break;
        case 'pending':
          return 'info';
          break;
        case 'solved':
          return 'success';
          break;
        case 'closed':
          return 'default';
          break;
      }
    }
  }
  
export default ZendeskModel;


// WEBPACK FOOTER //
// ./client/app/pages/zendesk/model/zendesk.model.js